export const CREATE_PRESENTATION = "presentation/create";
export const GET_TEMPLATES = "templates/get";
